// .u_amo-clone
class UAMOClone extends Uneet {
  constructor (domElement) {
    super(domElement)
    this.memberDirectory = null
    this.pageHead = null
    this.__init()
  }

  __init () {
    const memberDirDOMElem = this._e.querySelector('div.u_amo-member-directory-search')
    if (memberDirDOMElem) {
      this.memberDirectory = new UAMOMemberDirectorySearch(memberDirDOMElem)
    }

    const pageHeadElem = this._e.querySelector('div.u_amo-pagehead')
    if (pageHeadElem) {
      this.pageHead = new UAMOPageHead(pageHeadElem)
    }
  }

  test () {
    console.log('AMO Clone created succesfully')
  }
}

window.addEventListener('load', function () {
  const amoCloneDOMElement = document.querySelectorAll('body.u_amo-clone')[0]
  if (amoCloneDOMElement !== undefined) {
    const amoClone = new UAMOClone(amoCloneDOMElement)
    amoClone.test()
  }
})
